/*eslint-disable*/
import OfflineReminderItems from '../../../container/crm/offline/OfflineReminderItems';
import { ticketConversationLink } from '../../../container/ticket/ticketPresentation';
import { Badge, notification } from 'antd';
import axios from 'axios';
import FeatherIcon from 'feather-icons-react';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import io from 'socket.io-client';
import { offlineRequest } from '../../../container/crm/offline/offline.api';
import { basicAuth } from '../../../config/auth';
import { API, rootAPI } from '../../../config/api';
import { useAppDataContext } from '../../../hooks/useAppDataContext';
import { fetchUsers } from '../../../redux/users/actionCreator';
import Heading from '../../heading/heading';
import { Popover } from '../../popup/popup';
import { AtbdTopDropdwon } from './auth-info-style';

function NotificationBox() {
  const dispatch = useDispatch();
  const { rtl } = useSelector((state) => ({
    rtl: state.ChangeLayoutMode.rtlData,
  }));

  const { activeApp, isAdmin, auth, effectiveUser } = useAppDataContext(null);
  const socketRef = useRef(null);
  const [supportRequests, setSupportRequests] = useState([]);
  const [reminders, setReminders] = useState([]);
  const canReadReminders = !isAdmin && (auth.role !== 'Assistant' || effectiveUser?.permissions?.crm === true);
  const pendingRequests = supportRequests.filter(request => request.status === 'pending');
  const notificationCount = pendingRequests.length + reminders.length;

  useEffect(() => {
    setSupportRequests(effectiveUser?.supportRequests || []);
  }, [auth.id, effectiveUser?.supportRequests]);

  // Poll independently of the popover so the bell updates while it is closed.
  useEffect(() => {
    let active = true;
    let busy = false;
    let queued = false;
    setReminders([]);
    const refresh = async () => {
      if (busy) { queued = true; return; }
      busy = true;
      await Promise.allSettled([
        auth.id ? axios.get(`${API.auth.user}/${auth.id}`, { headers: { Authorization: `Basic ${basicAuth}` }, timeout: 15000 })
          .then(response => { if (active) setSupportRequests(response.data.user?.supportRequests || []); }) : Promise.resolve(),
        canReadReminders && activeApp?.app_id ? offlineRequest(activeApp.app_id, '/reminders')
          .then(entries => { if (active) setReminders(entries); }) : Promise.resolve(),
      ]);
      busy = false;
      if (queued && active) { queued = false; refresh(); }
    };
    refresh();
    const timer = setInterval(refresh, 30000);
    window.addEventListener('focus', refresh);
    window.addEventListener('support-notifications-changed', refresh);
    return () => { active = false; clearInterval(timer); window.removeEventListener('focus', refresh); window.removeEventListener('support-notifications-changed', refresh); };
  }, [auth.id, canReadReminders, activeApp?.app_id]);

  useEffect(() => {
    const appId = activeApp?.app_id || effectiveUser?.app_id;
    if (!appId) return;

    if (!socketRef.current) {
      socketRef.current = io(`${rootAPI}`);
      socketRef.current.emit('join_campaign_room', appId);
      socketRef.current.on('support_ticket_changed', () => window.dispatchEvent(new Event('support-notifications-changed')));

      socketRef.current.on('campaign_status', (data) => {
        if (data.type === 'INSUFFICIENT_MINUTES') {
          notification.error({
            message: 'Insufficient Minutes',
            description: data.message || 'Insufficient Minutes',
            duration: 8,
          });
        }
      });

      socketRef.current.on('incoming_call_status', (data) => {
        console.log('Incoming data', data);
        if (data.type === 'INSUFFICIENT_MINUTES') {
          notification.error({
            message: 'Incoming call rejected!',
            description:
              data.message ||
              `${data.phone} Incoming call could not be received due to insufficient available minutes."`,
            duration: 8,
            key: 'incoming_call_error',
          });
        }
      });
    }

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [activeApp?.app_id, effectiveUser?.app_id]);

  function renderThumb({ style, ...props }) {
    return <div style={{ ...style, borderRadius: 6, backgroundColor: '#F1F2F6' }} {...props} />;
  }

  const renderTrackVertical = () => (
    <div
      className="hello"
      style={{
        position: 'absolute',
        width: '6px',
        transition: 'opacity 200ms ease 0s',
        opacity: 0,
        [rtl ? 'left' : 'right']: '2px',
        bottom: '2px',
        top: '2px',
        borderRadius: '3px',
      }}
    />
  );

  function renderView({ style, ...props }) {
    return (
      <div {...props} style={{ ...style, marginRight: rtl && 'auto', [rtl ? 'marginLeft' : 'marginRight']: '-17px' }} />
    );
  }

  renderThumb.propTypes = { style: PropTypes.shape(PropTypes.object) };
  renderView.propTypes = { style: PropTypes.shape(PropTypes.object) };

  const content = (
    <AtbdTopDropdwon className="atbd-top-dropdwon">
      <Heading as="h5" className="atbd-top-dropdwon__title">
        <span className="title-text">Notifications</span>
        <Badge
          className="badge-success"
          style={{ borderRadius: 4 }}
          count={notificationCount}
        />
      </Heading>
      <Scrollbars
        autoHeight
        autoHide
        renderThumbVertical={renderThumb}
        renderView={renderView}
        renderTrackVertical={renderTrackVertical}
      >
        <ul className="atbd-top-dropdwon__nav notification-list">
          {notificationCount === 0 && <li style={{ padding: '20px', textAlign: 'center', color: '#868eae' }}>No new notifications</li>}
          {!isAdmin && <OfflineReminderItems appId={activeApp?.app_id} entries={reminders} onRead={id => setReminders(items => items.filter(({ _id: entryId }) => entryId !== id))} />}
          {pendingRequests.map((request, index) => (
              <li key={index}>
                <Link
                  to={ticketConversationLink(request, request.app_id || request.appId || activeApp?.app_id) || '/admin/ticket'}
                >
                  <div className="atbd-top-dropdwon__content notifications">
                    <div className="notification-icon bg-secondary" style={{ borderRadius: 6 }}>
                      <FeatherIcon icon="alert-circle" />
                    </div>
                    <div className="notification-content d-flex">
                      <div className="notification-text">
                        <Heading as="h5">
                          <span>{request.ticketNumber}</span>: {request.reason}
                        </Heading>
                        <p>{new Date(request.createdAt).toLocaleString()}</p>
                      </div>
                    </div>
                  </div>
                </Link>
              </li>
            ))}
        </ul>
      </Scrollbars>
      <Link className="btn-seeAll" to="/admin/ticket">
        View all support tickets
      </Link>
    </AtbdTopDropdwon>
  );

  return (
    <div className="notification">
      <Popover placement="bottomLeft" content={content} action="click">
        <Badge style={{ borderRadius: 4 }} count={notificationCount} overflowCount={99} offset={[-2, 0]} size="small">
          <button
            type="button"
            onClick={() => window.dispatchEvent(new Event('support-notifications-changed'))}
            aria-label={`Notifications, ${notificationCount} unread`}
            className="head-example"
            style={{ border: 0, background: 'transparent', padding: 0, color: 'inherit', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <FeatherIcon icon="bell" size={20} />
          </button>
        </Badge>
      </Popover>
    </div>
  );
}

export default NotificationBox;
